module.exports = __webpack_public_path__ + "static/img/no_birthday_info.dc2afc3b.png";